<template>
    <div v-if="farms > 0" class="farm">
        <span class="farm__count text-lg">{{ farms }}</span>
    </div>
</template>

<script>
    export default {
        name: "Farm",
        computed: {
            farms() {
                return this.$store.state.farms
            }
        }
    }
</script>

<style lang="scss" scoped>
    .farm {
        cursor: pointer;
        background: url('../../assets/images/farm_full.png') no-repeat;
        background-size: contain;
        position: relative;

        &__count {
            position: absolute;
            bottom: .5rem;
            right: .5rem;
            color: theme('colors.gray.100');
        }
    }
</style>